import { render, staticRenderFns } from "./FormularioSiniestro.vue?vue&type=template&id=f2584cd4&"
import script from "./FormularioSiniestro.vue?vue&type=script&lang=js&"
export * from "./FormularioSiniestro.vue?vue&type=script&lang=js&"
import style0 from "./FormularioSiniestro.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports